<div class="lang-title">
    <h2>
        <p color="primary" class="group-title">Grupo</p>
        <ion-text color="primary">
            {{ group.globalizationConfig[language].title || ('manageQuestionGroup.genericGroupName' | translate) + ' ' + group.order }}
            <ion-icon class="bp-edit manage-question-group" color="primary"
                      (click)="manageGroup()">
            </ion-icon>
        </ion-text>
    </h2>

    <div class="count-control">
        <div *ngIf="hasAttributesConfig" (click)="manageAttributes()" class="manage-attributes">  
      <span>
        {{ group.attributes.length }} {{ 'generic.attributes' | translate | uppercase }}
      </span>
            <ion-icon class="bp-setting" name="settingsCog"></ion-icon>
        </div>

        <ion-icon (click)="removeGroup()" class="bp-delete question-group-delete" name="delete"
                  color="danger"></ion-icon>
        <ion-button mode="ios"
                    (click)="moveDown()">
            <ion-icon class="bp-arrow-bottom-fill" name="btArrow"></ion-icon>
        </ion-button>

        <ion-input class="ion-text-center"
                   type="number" [disabled]="true"
                   [value]="group.order"
        ></ion-input>

        <ion-button mode="ios"
                    (click)="moveUp()"
                    [disabled]="group.order === 1">
            <ion-icon class="bp-arrow-top-fill" name="topArrow"></ion-icon>
        </ion-button>
    </div>
</div>

<div class="container-questions">
    <ng-container *ngFor="let question of group?.questions" class="container-questions">
        <ng-container [ngSwitch]="language">
            <app-question-configuration
                *ngSwitchCase="'pt-BR'"
                [isManagerQuestion]="isManagerGroup"
                [question]="question"
                [version]="version"
                [questionTypeConfigs]="questionTypeConfigs"
                [language]="'pt-BR'"
                [groupsSelectItems]="groupsSelectItems"
                (deleteQuestion)="deleteQuestion($event)"
                (reorderQuestions)="reorderQuestions($event)"
                (changeGroup)="changeGroup($event)"
                (updateQuestionTypeConfig)="updateQuestionTypeConfig($event)"
            ></app-question-configuration>

            <app-question-configuration
                *ngSwitchCase="'en-US'"
                [isManagerQuestion]="isManagerGroup"
                [question]="question"
                [version]="version"
                [questionTypeConfigs]="questionTypeConfigs"
                [language]="'en-US'"
                [groupsSelectItems]="groupsSelectItems"
                (deleteQuestion)="deleteQuestion($event)"
                (reorderQuestions)="reorderQuestions($event)"
                (changeGroup)="changeGroup($event)"
                (updateQuestionTypeConfig)="updateQuestionTypeConfig($event)"
            ></app-question-configuration>

            <app-question-configuration
                *ngSwitchCase="'es-ES'"
                [isManagerQuestion]="isManagerGroup"
                [version]="version"
                [question]="question"
                [questionTypeConfigs]="questionTypeConfigs"
                [language]="'es-ES'"
                [groupsSelectItems]="groupsSelectItems"
                (deleteQuestion)="deleteQuestion($event)"
                (reorderQuestions)="reorderQuestions($event)"
                (changeGroup)="changeGroup($event)"
                (updateQuestionTypeConfig)="updateQuestionTypeConfig($event)"
            ></app-question-configuration>
        </ng-container>
    </ng-container>
    <div class="add-question-group" (click)="addGroupQuestion()">
        <ion-label>+ {{ 'manageQuestionGroup.addQuestion' | translate }}</ion-label>
    </div>
</div>